export class PurchaseHistory {
    constructor() {
        let dropdown = document.getElementById("printYearDD") as HTMLSelectElement;
        //let button = document.getElementById("printHistoryBtn") as HTMLButtonElement;
        this.filterPurchaseHistoryOnDropdownChange(dropdown);
    };

    private filterPurchaseHistoryOnDropdownChange(dropdown: HTMLSelectElement) {
        if (dropdown) {
            dropdown.addEventListener('change', (e) => {
                let url: string = window.location.href;
                let yr: string = dropdown.options[dropdown.selectedIndex].text;
                url = url.substring(0, url.lastIndexOf('?')).concat((yr == "All") ? "" : "?year=" + yr);
                window.location.href = url;
            });
        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/purchase-history.ts